import { Component, OnInit} from '@angular/core';
import { LFDAPIService } from 'src/app/core/services/api';
import { Router } from '@angular/router';

import { SessionStorageService } from 'src/app/core/services/session_storage';
import { DataService } from 'src/app/core/services/data_service';
import { CalAngularService } from '@cvx/cal-angular';
import { MsGraphService } from 'src/app/core/services/ms-graph';
import { UntypedFormBuilder } from '@angular/forms';
import { formControlElement, formLabelElement } from 'src/app/animations/animations';
import { NzModalService } from 'ng-zorro-antd/modal';
import { EmailService } from 'src/app/core/services/email_service';
import { UserService } from 'src/app/core/services/user.service';
import { User } from 'src/app/core/models/user';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ErrorCode } from 'src/app/constants/constants';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.less'],
    animations: [formControlElement, formLabelElement],
    standalone: false
})

export class HomeComponent implements OnInit {
  currentUser: User = new User();
  isServerAvailable: boolean = true;
  constructor(private userService: UserService, private messaService: NzMessageService,) {
  }

  
 async ngOnInit() {
  this.isServerAvailable = true;
  
  this.currentUser = this.userService.getCurrentUser();
  // Subscribe to the userUpdated event
  this.userService.userUpdated.subscribe((updatedUser: User) => {
    this.currentUser = updatedUser;      
    
  });
  this.userService.apiInvokeError.subscribe((error: any) => {
    if(error == ErrorCode.SERVER_NOT_AVAILABLE) {
      this.isServerAvailable = false;      
    }
  });
  }
  
}
 